import Model from "../Model";

class Comercialclientzonetops extends Model{

    buildUrl ({ param }) {
        return ['zoneclientview/topzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Comercialclientzonetops;